import gql from 'graphql-tag'
import projectFragment from '../../fragments/project'

export default gql `mutation go($project_id: String!, $ids: [Int]!){
  removeProjectBudgets(project_id: $project_id, ids: $ids){
    ${projectFragment}
  }
}`